import { startCase } from 'lodash'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { LocationState } from './interfaces'

export default function useAnalytics() {
  const location = useLocation()
  const state = location.state as LocationState

  useEffect(() => {
    const dataLayer = window.dataLayer

    const pathname = location.pathname

    if (window.hj && typeof window.hj === 'function') hj?.('stateChange', pathname)

    window.dataLayer = dataLayer || []

    dataLayer.push({
      event: 'pgv_virtual',
      page_title: startCase(pathname),
      page_path: pathname,
      page_location: window.location.href,
      document_referrer: state?.previousPath,
    })
  }, [location])
}
